import { render, staticRenderFns } from "./ListaMensagensInscricao.vue?vue&type=template&id=5a2dc66e"
import script from "./ListaMensagensInscricao.vue?vue&type=script&lang=js"
export * from "./ListaMensagensInscricao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports